import React, { useState, useEffect, useCallback } from 'react';
import { adminApi } from '../../lib/api';

export default function PlatDuJourAdmin() {
  const [formules, setFormules] = useState([]);
  const [localData, setLocalData] = useState({});
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState(null);

  const loadFormules = useCallback(async () => {
    try {
      const res = await adminApi.getFormules();
      const list = res.data || [];
      setFormules(list);
      const init = {};
      list.forEach(f => {
        init[f.id] = { platDuJour: f.platDuJour || '', ardoiseUrl: f.ardoiseUrl || '' };
      });
      setLocalData(init);
    } catch (e) {
      setError('Impossible de charger les formules');
    }
  }, []);

  useEffect(() => { loadFormules(); }, [loadFormules]);

  const handleSave = async (formuleId) => {
    setSaving(true);
    setSaved(false);
    setError(null);
    try {
      const formule = formules.find(f => f.id === formuleId);
      if (!formule) return;
      await adminApi.updateFormule(formuleId, {
        ...formule,
        platDuJour: localData[formuleId]?.platDuJour || '',
        ardoiseUrl: localData[formuleId]?.ardoiseUrl || '',
      });
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (e) {
      setError('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  const platDuJourFormule = formules.find(f => f.nom === 'Plat du Jour');

  return (
    <div style={{ maxWidth: 640, margin: '0 auto', padding: '32px 24px', fontFamily: 'sans-serif' }}>
      <h1 style={{ fontSize: 24, fontWeight: 800, color: '#1a2e12', marginBottom: 8 }}>
        Plat du Jour
      </h1>
      <p style={{ color: '#666', marginBottom: 32, fontSize: 14 }}>
        Mettez a jour le plat du jour chaque matin. Vous pouvez copier-coller directement depuis Google Lens.
      </p>

      {error && (
        <div style={{ background: '#fee2e2', border: '1px solid #f87171', borderRadius: 8, padding: '12px 16px', marginBottom: 24, color: '#dc2626', fontSize: 14 }}>
          {error}
        </div>
      )}

      {saved && (
        <div style={{ background: '#dcfce7', border: '1px solid #86efac', borderRadius: 8, padding: '12px 16px', marginBottom: 24, color: '#16a34a', fontSize: 14 }}>
          Sauvegarde reussie !
        </div>
      )}

      {platDuJourFormule ? (
        <div style={{ background: '#fff', border: '2px solid #e8e0d4', borderRadius: 16, padding: '24px', marginBottom: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
            <span style={{ fontSize: 32, fontWeight: 900, color: '#5a7a3c' }}>15 EUR</span>
            <span style={{ background: '#f5c842', color: '#1a2e12', fontSize: 11, fontWeight: 800, padding: '4px 12px', borderRadius: 20, textTransform: 'uppercase' }}>Plat du Jour</span>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontWeight: 600, color: '#333', marginBottom: 6, fontSize: 13 }}>
              Description du plat (affichee sur le site)
            </label>
            <textarea
              value={localData[platDuJourFormule.id]?.platDuJour || ''}
              onChange={e => setLocalData(prev => ({ ...prev, [platDuJourFormule.id]: { ...prev[platDuJourFormule.id], platDuJour: e.target.value } }))}
              placeholder="Ex: Magret de canard, sauce aux cèpes, gratin dauphinois..."
              rows={4}
              style={{ width: '100%', border: '1.5px solid #d1d5db', borderRadius: 8, padding: '10px 12px', fontSize: 14, fontFamily: 'sans-serif', resize: 'vertical', boxSizing: 'border-box' }}
            />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', fontWeight: 600, color: '#333', marginBottom: 6, fontSize: 13 }}>
              Photo de l ardoise (URL optionnelle)
            </label>
            <input
              type="text"
              value={localData[platDuJourFormule.id]?.ardoiseUrl || ''}
              onChange={e => setLocalData(prev => ({ ...prev, [platDuJourFormule.id]: { ...prev[platDuJourFormule.id], ardoiseUrl: e.target.value } }))}
              placeholder="https://... (laissez vide si pas de photo)"
              style={{ width: '100%', border: '1.5px solid #d1d5db', borderRadius: 8, padding: '10px 12px', fontSize: 14, boxSizing: 'border-box' }}
            />
          </div>
          <button
            onClick={() => handleSave(platDuJourFormule.id)}
            disabled={saving}
            style={{ background: saving ? '#9ca3af' : '#5a7a3c', color: '#fff', border: 'none', borderRadius: 8, padding: '12px 24px', fontSize: 14, fontWeight: 700, cursor: saving ? 'not-allowed' : 'pointer' }}
          >
            {saving ? 'Sauvegarde...' : 'Sauvegarder'}
          </button>
        </div>
      ) : (
        <div style={{ background: '#fef9c3', border: '1px solid #fbbf24', borderRadius: 12, padding: 20, fontSize: 14, color: '#92400e' }}>
          Aucune formule "Plat du Jour" trouvee. Verifiez que le seed a ete execute.
        </div>
      )}
    </div>
  );
}
